import AppReviews from './AppReviews';

export default AppReviews;
